import React, { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconEdit } from '../../../../../../assets/icons/icon-edit';
import { DialogTimePicker, InputMui } from '../../../../../../components';

type TimeInputProps = {
  time: string;
  setTime: Dispatch<SetStateAction<string>>;
  label?: string;
  minSeconds?: number;
};

export const TimeInput: React.FC<TimeInputProps> = ({ time, setTime, label, minSeconds }) => {
  const { t } = useTranslation('action');
  const [showTimePicker, setShowTimePicker] = useState<boolean>(false);

  return (
    <>
      <InputMui
        value={time}
        readOnly
        label={label || t('action.create.conditions.sources.schedule.triggerTime')}
        onClickInput={() => setShowTimePicker(true)}
        endIcon={<IconEdit />}
      />
      <DialogTimePicker
        header={t('action.create.conditions.sources.schedule.triggerTime')}
        open={showTimePicker}
        setOpen={setShowTimePicker}
        onSave={(value) => setTime(value)}
        time={time}
        showSeconds
        minSeconds={minSeconds}
      />
    </>
  );
};
